import context from '@/context'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { allowErrorDialog } from '@/utils/fetch'
import getComponentKey from '@/utils/getComponentKey'

export const initialState = {
  retrieving: false,
  outputReportGroupDefinition: null,

  saving: false,
  componentKey: getComponentKey(),
  gridComponentKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'outputReportGroupDefinition/fetching',
  fetched: 'outputReportGroupDefinition/fetched',
  error: 'outputReportGroupDefinition/error',

  setGridKey: 'outputReportGroupDefinition/gridKey',

  updating: 'outputReportGroupDefinition/updating',
  updated: 'outputReportGroupDefinition/updated',
  created: 'outputReportGroupDefinition/created'
}

const areTemplatesValid = (templates) => {
  /* if (templates && templates.length > 1) {
    const first = templates[0].multipleInstitutions
    return !templates.find(x => x.multipleInstitutions !== first)
  } */
  return true
}

const showValidationError = (dispatch) => {
  dispatch(
    dialogActions.openDialog({
      dialogType: dialogTypes.alert,
      title: 'Common.ValidationError',
      content: 'Reporting.TemplatesValidationError'
    })
  )
}
export const actionCreators = {

  get: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.fetching, data: id })
    context.api.outputReportGroupDefinitionService.get(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  update: (dto) => (dispatch, getState) => {
    if (areTemplatesValid(dto.templates)) {
      dispatch({ type: actionTypes.updating })
      context.api.outputReportGroupDefinitionService.update(dto, allowErrorDialog)
        .then(response => {
          dispatch({ type: actionTypes.updated, data: dto })
          if (response === true) { dispatch(actionCreators.get(dto.id)) }
        })
        .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
    } else {
      showValidationError(dispatch)
    }
  },
  create: (dto) => (dispatch, getState) => {
    if (areTemplatesValid(dto.templates)) {
      dispatch({ type: actionTypes.updating })
      context.api.outputReportGroupDefinitionService.create(dto, allowErrorDialog)
        .then(id => {
          dispatch({ type: actionTypes.created, data: id })
        })
        .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
    } else {
      showValidationError(dispatch)
    }
  },
  setGridKey: () => (dispatch) => dispatch({ type: actionTypes.setGridKey })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.setGridKey:
      return {
        ...state,
        gridComponentKey: getComponentKey()
      }
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, outputReportGroupDefinition: action.data, componentKey: getComponentKey() }
    case actionTypes.updating: return { ...state, updating: true }
    case actionTypes.updated: return { ...state, updating: false, outputReportGroupDefinition: action.data }
    case actionTypes.created: return { ...state, updating: false, outputReportGroupDefinition: { ...state.outputReportGroupDefinition, id: action.data }, gridComponentKey: getComponentKey() }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/outputReportGroupDefinitions.js